<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" dark flat class="orange darken-3">
      <v-icon small dark class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Alert</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedAlerts" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
            <v-card-text>             
            <v-text-field
              name="editedAlertsName"
              v-model="editedAlertsName"
              label="Alert"
              multi-line              
              id="editedAlertsName"
            ></v-text-field>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['alert'],
  data () {
    return {
      editDialog: false,
      editedAlerts: this.alert,
      editedAlertsName: this.alert.alertName
    }
  },
  computed: {
    loadAlerts () {
      return this.$store.getters.loadedAlerts
    }
  },
  methods: {
    onSaveChanges () {
      this.editDialog = false
      this.alert = true
      console.log('ALERT ALERT ALERT:' + alert)
      this.$store.dispatch('updateAlertData', {
        alertId: this.alert.alertId,
        alertName: this.editedAlertsName
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditAlertsDialog.vue?40757ea0